import request from '@/config/axios'

export type AudioSeries = {
  id: number
  coverUrl: string
  ageStage: string
  chineseName: string
  englishName: string
  description: string
}

export type AudioVO = {
  id: number
  audioUrl: string
  name: string
  createTime: string
  isFavorite?: number
}

export const getAudioSeriesPage = (params: any) => {
  return request.get({
    url: '/audio-series/page',
    params
  })
}

export const getAudioSeries = (id: any) => {
  return request.get({
    url: '/audio-series/get?id=' + id
  })
}

export const getAudioPage = (params: any) => {
  return request.get({
    url: '/audio/page',
    params
  })
}
